import { render, staticRenderFns } from "./singlePartList.vue?vue&type=template&id=1232d486&scoped=true"
import script from "./singlePartList.vue?vue&type=script&lang=js"
export * from "./singlePartList.vue?vue&type=script&lang=js"
import style0 from "./singlePartList.vue?vue&type=style&index=0&id=1232d486&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1232d486",
  null
  
)

export default component.exports